/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FlowMonitor } from './FlowMonitor';
import { getTransactionMeta } from '../transactionMeta';
export class PasswordRecoveryFlowMonitor extends FlowMonitor {
    isRemediatorCandidate(remediator, remediations, values) {
        var _a;
        const prevRemediatorName = (_a = this.previousRemediator) === null || _a === void 0 ? void 0 : _a.getName();
        const remediatorName = remediator.getName();
        if (remediatorName === 'select-authenticator-authenticate'
            && [
                'select-authenticator-authenticate',
                'reenroll-authenticator'
            ].includes(prevRemediatorName)) {
            return false;
        }
        if (remediatorName === 'select-authenticator-authenticate'
            && remediations.some(({ name }) => name === 'challenge-authenticator')) {
            return false;
        }
        return super.isRemediatorCandidate(remediator, remediations, values);
    }
    isFinished() {
        const _super = Object.create(null, {
            isFinished: { get: () => super.isFinished }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const { remediations } = yield getTransactionMeta(this.authClient);
            if (!remediations.includes('reset-authenticator')) {
                return false;
            }
            return yield _super.isFinished.call(this);
        });
    }
}
